import React from 'react'
import Heading from './shared/Heading'

export default (type, element, content, children, key) => (
  <Heading
    component='h2'
    fontSize={{ xs: 22 / 16, md: 25 / 16}}
    lineHeight={{ xs: 25 / 16, md: 27 / 16}}
    wordBreak='break-word'
    key={key}
  >
    {children}
  </Heading>
)
